module.exports = __webpack_public_path__ + "static/project4-3ecace795aba3cfa96d182e04fc1ca04.jpg";